import axios from "axios";

export const getTaskTypeStatistics = ({ id, organization, years }) => {
  const requestUrl = `/team/task-type/statistics`;

  let params = {
    id,
    years,
    organization
  };
  return axios.get(requestUrl, {
    params
  });
};



// WEBPACK FOOTER //
// ./src/api/statistics.js